import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: !window.location.href.includes("test")
    ? process.env.REACT_APP_API_URL
    : "https://apitest.glassen-it.com/component/socparser/",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const publicationsApi = createApi({
  reducerPath: "publications",
  baseQuery: baseQueryWithAuth,
  endpoints: ({ query }) => ({
    publications: query({
      query: (body) => ({
        url: "content/posts",
        credentials: "include",
        method: "POST",
        body,
      }),
    }),
    lastDate: query({
      query: (body) => ({
        url: "content/getLastPostDate",
        credentials: "include",
        method: "POST",
        body,
      }),
    }),
    periodGet: query({
      query: (body) => ({
        url: "/thread/settings_periods_get",
        credentials: "include",
        method: "POST",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { usePublicationsQuery, useLastDateQuery, usePeriodGetQuery } = publicationsApi;
